module.exports = __webpack_public_path__ + "static/media/Homepage - StocksPhoto.e162e173.png";